import { useEffect } from 'react';

import type { PageMetaInput } from '../utils/pageMeta';
import { applyPageMeta } from '../utils/pageMeta';

export function usePageMeta(meta: PageMetaInput) {
  useEffect(() => {
    applyPageMeta(meta);
  }, [meta.title, meta.description, meta.keywords, meta.ogType, meta.ogImage, meta.canonicalPath, meta.noIndex]);
}
